import { diToFormData, type VaultFormData } from '@onefootprint/core';
import type { Iso3166TwoDigitCountryCode, VaultData } from '@onefootprint/request-types';
import uniq from 'lodash/uniq';
import { UsLegalStatus } from './constants';
import type { CitizenshipsFormData, UsLegalStatus as UsLegalStatusType, VisaKind } from './types';

type UsLegalStatusDefaultValues = Partial<VaultFormData> & CitizenshipsFormData;

export const EMPTY_CITIZENSHIPS: CitizenshipsFormData = {
  citizenships: [{ value: undefined }],
};

export const getDefaultValuesFromVault = (vault: VaultData): UsLegalStatusDefaultValues => {
  const usLegalStatus = (vault['id.us_legal_status'] as UsLegalStatusType) ?? UsLegalStatus.citizen;

  const citizenships = vault['id.citizenships']
    ? vault['id.citizenships'].map(value => ({ value }))
    : EMPTY_CITIZENSHIPS.citizenships;

  const nationality =
    usLegalStatus === UsLegalStatus.citizen
      ? 'US'
      : ((vault['id.nationality'] as Iso3166TwoDigitCountryCode) ?? undefined);

  return {
    [diToFormData('id.us_legal_status')]: usLegalStatus,
    [diToFormData('id.nationality')]: nationality,
    [diToFormData('id.visa_kind')]: vault['id.visa_kind'] as VisaKind | undefined,
    [diToFormData('id.visa_expiration_date')]: vault['id.visa_expiration_date'],
    citizenships,
  };
};

export const applyCitizenshipsToVaultData = (
  vaultData: VaultData,
  citizenships: CitizenshipsFormData['citizenships'],
): void => {
  // Remove the citizenships field that hookFormToVaultData doesn't understand
  delete (vaultData as Record<string, unknown>).citizenships;

  // Set citizenships based on legal status
  if (vaultData['id.us_legal_status'] === UsLegalStatus.citizen) {
    vaultData['id.citizenships'] = ['US'];
  } else if (citizenships) {
    const citizenshipValues = uniq(citizenships.filter(c => c.value).map(c => c.value as Iso3166TwoDigitCountryCode));
    if (citizenshipValues.length > 0) {
      vaultData['id.citizenships'] = citizenshipValues;
    }
  }
};
